<div class="capacity-warning-dialog">
  <div class="close-button" (click)="onDismiss()">
    <button mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="dialog-content">
    <div class="icon-container">
      <img [src]="iconPath" alt="Warning Icon">
    </div>
    
    <div class="message-container">
      <p class="message">{{ message }}</p>
      <p class="subtitle">Please Select How You Want this Change to Take Effect</p>
    </div>
    
    <div class="button-container">
      <button mat-stroked-button class="left-button" (click)="onLeftButtonClick()">
        {{ leftButtonText }}
      </button>
      <button mat-stroked-button class="right-button" (click)="onRightButtonClick()">
        {{ rightButtonText }}
      </button>
    </div>
  </div>
</div> 